import { newID } from "../models.js";
import type { EffortWord, Item, ItemKind, RunKind, RunStart, Surface } from "./types.js";

export function newRowID(): string {
  return newID();
}

export function blankItem(kind: ItemKind = "lift"): Item {
  return { id: newRowID(), kind, name: "" };
}

/** His scale, lightest first, as the `Weights:` legend words it. */
export const EFFORT_WORDS: readonly { word: EffortWord; label: string }[] = [
  { word: "very light", label: "Very light" },
  { word: "light", label: "Light" },
  { word: "medium", label: "Medium" },
  { word: "heavy", label: "Heavy" },
  { word: "very heavy", label: "Very heavy" },
];

/** `word` is how the kind is written in a line. */
export const RUN_KINDS: readonly { kind: RunKind; label: string; word: string }[] = [
  { kind: "sprint", label: "Sprint", word: "sprint" },
  { kind: "accel", label: "Accel", word: "accel" },
  { kind: "tempo", label: "Tempo", word: "tempo" },
  { kind: "resisted", label: "Resisted", word: "resisted" },
  { kind: "skips", label: "Skips", word: "skip" },
  { kind: "slowBuild", label: "Slow build", word: "slow build" },
  { kind: "timeTrial", label: "Time trial", word: "TT" },
  { kind: "run", label: "Run", word: "" },
];

export const RUN_STARTS: readonly { start: RunStart; label: string; words: string }[] = [
  { start: "blocks", label: "Blocks", words: "from blocks" },
  { start: "3-point", label: "3-point", words: "from 3-point" },
  { start: "walk-in", label: "Walk-in", words: "from walk-in start" },
  { start: "standing", label: "Standing", words: "from standing start" },
  { start: "fly", label: "Fly", words: "fly" },
];

export const SURFACES: readonly { surface: Surface; label: string }[] = [
  { surface: "grass", label: "Grass" },
  { surface: "turf", label: "Turf" },
  { surface: "track", label: "Track" },
  { surface: "sand", label: "Sand" },
];
